<template>
  <div>
    <h2>欢迎来到水质检测管理系统</h2>
    <p>这是首页内容。</p>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
};
</script>

<style scoped>
.home {
  text-align: center;
  padding: 20px;
}
</style>

